(function () {
    'use strict';

    angular
        .module('sodDocumentLibrary')
        .constant('DocumentLibraryConstant', {
            DOCUMENT_LIBRARY_DIALOG_IDENTIFIER: 'document-library',
            ACTION_OPEN_DOCUMENT_LIBRARY: ''
        });
})();